import {Box, Stack, Typography} from '@mui/material'
import React, {useState, useEffect} from 'react'
import LabelInput from '../../customTable/LabelInput'
import RedStart from '../../customTable/RedStart'
import InputType from '../../customTable/InputType'
import Tabs from './TabsWithOutFlag'
import TextErea from '../../customTable/TextErea'
import InputColor from '../../customTable/InputColor'
import UpdateFile from './UpdateFile'
import ErrorMsg from '../../customTable/ErrorMsg'
import TabsLangWithFlag from '../../customTable/LangTabs'
import Langs from '../../../Api/SettingLangs'
import {AnyAction} from '@reduxjs/toolkit'
import {useSelector} from 'react-redux'
import {RootState} from '../../../store'
import {useTranslation} from 'react-i18next'
import UploadImgBtn from '../../customTable/UploadImgBtn'
import Label from '../../customTable/Label'
import Switch from '../../../componet/Toastr/Switch'
import EditFoter from './EditFoter'

export default function Contant({setting, setSeeting, msgErr, errors}: any) {
  const [base64Image, setBase64Image] = React.useState('')
  const {t} = useTranslation()

  const [data, setData] = useState<any>({})

  const [defLang, setDefLang] = useState('')
  const store = useSelector((state: RootState) => state.vender)

  const getLangs = async () => {
    setSelectedLang(store.langs)
    setDefLang(
      store.langs.some((e: any) => e.code === store.defLang) ? store.defLang : store.langs[0].code
    )
  }
  const [selectedLang, setSelectedLang] = useState<any>([])
  useEffect(() => {
    getLangs()
  }, [store.langs])
  const copyLink = () => {
    navigator.clipboard
      .writeText(setting.identity_papers)
      .then(() => {})
      .catch(() => {})
  }
  const {myPackage} = useSelector((state: RootState) => state.vender)

  return (
    <Stack
      p='24px'
      borderRadius={'8px'}
      bgcolor={'var(--bs-app-header-base-bg-color)'}
      width={'100%'}
      minHeight={'351px'}
      mt={'23px'}
    >
      {/* <LabelInput text={t('identityPaper')} /> */}

      <Stack gap={'10px'}>
        <LabelInput text={t('siteUrl')} />
        <Stack
          bgcolor={'var(--bs-app-bg-color)'}
          gap='12px'
          alignItems={'center'}
          direction={'row'}
          borderRadius={'8px'}
          p='18px'
          sx={{color: '#009AFF', cursor: 'pointer'}}
          onClick={() => {
            const domain = localStorage.getItem('domain')
            if (domain) {
              window.open(domain, '_blank')
            } else {
              console.error('Domain not found in localStorage')
            }
          }}
        >
          <Typography>{localStorage.getItem('domain')} </Typography>
        </Stack>
      </Stack>

      <Stack width={'100%'}>
        <Stack width={'100%'}>
          <Stack
            gap='24px'
            justifyContent={'space-between'}
            flexWrap={'wrap'}
            direction={'row'}
            mt='48px'
          >
            <Stack width={{lg: '48%', xs: '100%'}}>
              {selectedLang.map((e: any, i: number) => (
                <>
                  {e.code === defLang && (
                    <Stack gap='10px'>
                      <label style={{display: 'flex', gap: '5px'}} htmlFor={e.code}>
                        <LabelInput text={t('siteTitle')} />

                        <RedStart />
                      </label>
                      <Box position={'relative'} sx={{width: {sm: '100%', xs: '100%'}}}>
                        <InputType
                          errors={errors}
                          name={'title'}
                          change={setSeeting}
                          value={setting}
                          type='text'
                          child={e.code}
                          characters={70}
                        />
                        <TabsLangWithFlag
                          name='title'
                          pb={1}
                          activeLang={defLang}
                          setActiveLang={setDefLang}
                          errors={errors}
                          languages={selectedLang}
                        />
                        {/* <Tabs /> */}
                        <ErrorMsg msgErr={msgErr} name='title' />
                      </Box>
                    </Stack>
                  )}
                </>
              ))}
            </Stack>
            <Stack width={{lg: '48%', xs: '100%'}} gap='10px'>
              <label style={{display: 'flex', gap: '5px'}}>
                <LabelInput text={t('storeMobileNumber')} />

                <RedStart />
              </label>
              <Box position={'relative'} sx={{width: {sm: '100%', xs: '100%'}}}>
                <Stack dir='ltr'>
                  <InputType
                    checked
                    errors={errors}
                    name={'mobile'}
                    change={setSeeting}
                    value={{mobile: `${setting.phone_code}${setting.mobile}`}}
                    type='text'
                  />
                </Stack>

                {/* <ErrorMsg msgErr={msgErr} name='Description' /> */}
              </Box>
            </Stack>
          </Stack>
          <Stack mt='24px' width={{sm: '100%', xs: '100%'}}>
            {selectedLang.map((e: any, i: AnyAction) => (
              <>
                {e.code === defLang && (
                  <Stack gap='10px'>
                    <label style={{display: 'flex', gap: '5px'}} htmlFor={e.code}>
                      <LabelInput text={t('description')} />

                      <RedStart />
                    </label>
                    <Box position={'relative'} sx={{width: {sm: '100%', xs: '100%'}}}>
                      <TextErea
                        characters={160}
                        errors={errors}
                        name={'description'}
                        change={setSeeting}
                        value={setting}
                        child={e.code}
                      />
                      <TabsLangWithFlag
                        pb={1}
                        errors={errors}
                        name={'description'}
                        activeLang={defLang}
                        setActiveLang={setDefLang}
                        languages={selectedLang}
                      />{' '}
                    </Box>
                  </Stack>
                )}
              </>
            ))}
          </Stack>
          <Stack
            gap='24px'
            justifyContent={'space-between'}
            flexWrap={'wrap'}
            direction={'row'}
            mt='24px'
          >
            {<EditFoter white_label={setting.white_label} />}

            <Stack width={{lg: '48%', xs: '100%'}} gap='10px'>
              <label style={{display: 'flex', gap: '5px'}}>
                <LabelInput text={t('currency')} />
              </label>
              <Box position={'relative'} sx={{width: {sm: '100%', xs: '100%'}}}>
                <InputType
                  errors={errors}
                  checked={true}
                  name={'currency'}
                  change={setData}
                  value={
                    {currency: localStorage.getItem('currency')}
                  }
                  type='text'
                />
                {/* <ErrorMsg msgErr={msgErr} name='Description' /> */}
              </Box>
            </Stack>
            <Stack width={{lg: '48%', xs: '100%'}} gap='10px'>
              <label style={{display: 'flex', gap: '5px'}}>
                <LabelInput text={t('email')} />
                <RedStart />
              </label>
              <Box position={'relative'} sx={{width: {sm: '100%', xs: '100%'}}}>
                <InputType
                  errors={errors}
                  change={setSeeting}
                  value={setting}
                  name={'email'}
                  type='text'
                />
              </Box>
            </Stack>
            <Stack width={{lg: '48%', xs: '100%'}} gap='10px'>
              <label style={{display: 'flex', gap: '5px'}}>
                <LabelInput text={t('defaultsku')} />
              </label>
              <Box position={'relative'} sx={{width: {sm: '100%', xs: '100%'}}}>
                <InputType
                  characters={10}
                  errors={errors}
                  name={'default_sku'}
                  change={setSeeting}
                  value={setting}
                  type='text'
                />
                {/* <ErrorMsg msgErr={msgErr} name='Description' /> */}
              </Box>
            </Stack>
            <Stack width={{lg: '48%', xs: '100%'}} gap='10px'>
              <label style={{display: 'flex', gap: '5px'}}>
                <LabelInput text={t('templateColor')} />
              </label>
              <Box position={'relative'} sx={{width: {sm: '100%', xs: '100%'}}}>
                <InputColor name={'color'} change={setSeeting} value={setting} type='color' />
                {/* <ErrorMsg msgErr={msgErr} name='Description' /> */}
              </Box>
            </Stack>

            <Stack alignItems={'center'} gap='24px' direction={'row'}>
              <Label fw='600' text={'putYourStoreUnderRepair'} />
              <Switch
                name='status'
                value={setting.is_maintenance === 1 ? true : false}
                handleChange={() => {
                  setSeeting({...setting, is_maintenance: setting.is_maintenance === 1 ? 0 : 1})
                }}
              />
            </Stack>
            <Stack alignItems={'center'} gap='24px' direction={'row'}>
              <Label fw='600' text={'ShowStoreTitleInHeader'} />
              <Switch
                name='status'
                value={setting.is_show_store_title === 1 ? true : false}
                handleChange={() => {
                  setSeeting({
                    ...setting,
                    is_show_store_title: setting.is_show_store_title === 1 ? 0 : 1,
                  })
                }}
              />
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}
